<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStation } from '@/store/station';
import { useUserStore } from '@/store/user';

const station = useStation();
const user = useUserStore();
const { t } = useI18n();

const props = defineProps<{
  isAuthorizedStation: boolean
}>();

const emit = defineEmits<{
  toggle: []
}>();

const is_charge_button_available = computed(() => {
  return !station.charging && user.logged && props.isAuthorizedStation
});

</script>

<template>
  <v-btn
    class="text-button mb-10 font-weight-bold"
    min-width="210"
    min-height="50"
    size="x-large"
    color="success"
    :disabled="!is_charge_button_available"
    @click="emit('toggle')"
  >
    <!-- @click="$emit('toggleConfirmation')" -->
    {{ t("start") }}
  </v-btn>
</template>

<i18n lang="yml">
en:
  start: "Start charge"
it:
  start: "Attivare la ricarica"
fr:
  start: "Démarrer la charge"
de:
  start: "Laden aktivieren"
nl:
  start: "Opladen starten"
</i18n>

<style scoped lang="scss">
</style>

<!-- vim: softtabstop=2:shiftwidth=2
-->
